import { getLangCode } from "@/app/(site)/_utils/misc"
import LinksContentCard2 from "../LinksContentCard2"
import { t } from "@/translations"
type LinksContentCardProps = {
    selectedCategoryChildren: any //fix this type
    paramsLocale: string
    data?: any //fix this type
}

export default function CentraCategoryLinksContentCard({
    paramsLocale,
    selectedCategoryChildren,
    data
}: LinksContentCardProps) {
    const languageCode = getLangCode(paramsLocale)
    const linksCardTitle = languageCode ? t(languageCode, "explore more products") : ""
    return (
        <LinksContentCard2
            title={linksCardTitle}
            links={selectedCategoryChildren?.children}
        ></LinksContentCard2>
    )
}
